module.exports = __webpack_public_path__ + "static/contact-image-bdf7fbc9d3f9bbc571cab5ddb31a70db.png";